import React from 'react';
import { Link as UiLink } from '@make-software/cspr-design';
import type { LinkProps } from '@make-software/cspr-design';
import styled from 'styled-components';

const StyledLink = styled(UiLink)(() => ({
  '&&': {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'inline-flex',
    minHeight: 24,
  },
}));

export const Link = (props: LinkProps) => (
  <StyledLink lineHeight={'sm'} {...props} />
);
